import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, Platform, ToastController} from 'ionic-angular';

import {QuizzQuestionSelfieOnAppPage} from '../quizz-question-selfie-on-app/quizz-question-selfie-on-app';
import {QuizzQuestionSelfieOnWebPage} from '../quizz-question-selfie-on-web/quizz-question-selfie-on-web';

import {AlertProvider} from '../../providers/alert/alert';
import {QuizzServerProvider} from '../../providers/quizz-server/quizz-server';


/**
 * Generated class for the QuizzQuestionPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-quizz-question',
  templateUrl: 'quizz-question.html',
})
export class QuizzQuestionPage {

  loading: boolean = false;
  question: any = null;
  fileKind: string = null;
  fileUrl: string = null;
  answer: any = null;

  constructor(
    private navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private platform: Platform,
    private quizzServerProvider: QuizzServerProvider,
    private alertProvider: AlertProvider,
  ) {
    this.loading = true;

    let loader = this.loadingCtrl.create({
      content: 'Obtendo a pergunta...',
    });
    loader.present();

    let that = this;

    this.quizzServerProvider.fetchNextQuestion().subscribe((data: any) => {
      that.loading = false;
      loader.dismiss();

      try {
        // console.log(data);
        that.question = data;

        if ((that.question.file) && (that.question.file.id > 0)) {
          that.fileKind = that.question.file.kind;
          that.fileUrl = that.quizzServerProvider.fetchNextQuestionMediaUrl();
        }
      } catch (ex) {
        that.doNotRetrivedQuestion(ex);
      }
    }, (error: any) => {
      that.loading = false;
      loader.dismiss();
      that.doNotRetrivedQuestion(error);
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad QuizzQuestionPage');
  }

  private doNotRetrivedQuestion(error = null) {
    this.question = null;

    console.log('Não foi possível obter a pergunta.', error);

    let toast = this.toastCtrl.create({
      message: 'Não foi possível obter a pergunta.',
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  doAnswer() {
    // console.log(this.question.id, this.answer);
    if (this.answer === null) {
      this.alertProvider.doAlert('Selecione uma resposta.');
    } else {
      const data = {
        'answer': this.answer,
      };

      let loader = this.loadingCtrl.create({
        content: 'Respondendo a pergunta...',
      });
      loader.present();

      let that = this;

      this.quizzServerProvider.answerQuestion(this.question.id, data).subscribe((data: any) => {
        loader.dismiss();

        try {
          // console.log(data);

          if (data.result) {
            that.alertProvider.doInfoAlert('Parabéns! Sua resposta está correta. Atente-se aos próximos passos para validar a questão.');

            that.quizzServerProvider.setQuizzId(that.question.quizzId);
            that.quizzServerProvider.setQuestionId(that.question.id);

            if (that.platform.is('cordova')) {
              that.navCtrl.setRoot(QuizzQuestionSelfieOnAppPage);
            } else {
              that.navCtrl.setRoot(QuizzQuestionSelfieOnWebPage);
            }

            that.navCtrl.popToRoot({
              animation: 'md-transition',
            }, () => {
              // Do nothing.
            });
          } else {
            that.alertProvider.doAlert('Que pena! A resposta está incorreta. Leia atentamente o conteúdo da pergunta e tente novamente.');
          }
        } catch (ex) {
          that.doNotAnswerQuestion(ex);
        }
      }, (error: any) => {
        loader.dismiss();
        that.doNotAnswerQuestion(error);
      });
    }
  }

  private doNotAnswerQuestion(error = null) {
    console.log('Não foi possível responder a pergunta.', error);

    let toast = this.toastCtrl.create({
      message: 'Não foi possível responder a pergunta.',
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/quizz-question/quizz-question.ts